type ToggleButtonProps = {
  // number for type of toggle 1=> normal, 2=> with text yes-no
  type: 1 | 2;
  checked?: boolean;
  onToggle?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const ToggleButton = ({ type, checked, onToggle, disabled=false }: ToggleButtonProps) => {
  return (
    <div className={`box${type}`}>
      <input type="checkbox" defaultChecked={checked || false} onChange={onToggle} disabled={disabled} />
      <span className="toogle">
        <span />
      </span>
    </div>
  );
};
export default ToggleButton;
